import React, { useContext, useEffect, useState } from 'react'
import AdminContext from '../../../StateContext/Application'
import {useParams } from 'react-router-dom'
import { saveAs } from 'file-saver';
import '../../page.css'
const GenerateRefund = () => {
  const { id, AuctionName } = useParams()
  const data = useContext(AdminContext)
  const { GenerateRefund, EcsUpload, SendRefund,CreateToken,ApprovalRefund } = data
  const [renderdata, SetRenderdata] = useState([])
  const [WinnerData, SetWinnerData] = useState([])
  const [EToken, SetEToken] = useState(false)
  const [gentoken, settoken] = useState(true)
  const [hide, sethide] = useState(true)
  const [searchdata, SetSearchData] = useState([])
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = renderdata.slice(indexOfFirstItem, indexOfLastItem);
  const [csvdata,setcsvdata]=useState()
  const [Message, setMessage] = useState("");
  var csv = [["key", "refund_amount", "phone", "email", "Account_Number","IFSC_CODE","BANK_NAME","Account_HolderName","PANCARD","GSTNO","TXNID"]]
  useEffect(() => {
    getlist()
  }, [])

  async function getlist() {
    try {
      let d = await GenerateRefund("Getlist", id);
      console.log(d);
      SetRenderdata(d);
    } catch (error) {
      console.error('Error getting list:', error);
    }
  }

  const addlist = (target, e) => {
    try {
      if (target.checked) {
        csv.push([e.Regiterationid, e.ErnestMoneyDeposit, e.Mobile_No, e.Email, e.Account_Number, e.IFSC_CODE, e.BANK_NAME, e.Account_HolderName,e.PAN_No,e.GST_No,e.easepayid]);
        setcsvdata(csv);
      } else {
        csv.forEach((x) => {
          if (x[0] == e.Regiterationid) {
            alert('This Will Alter The Data Please Do not do any manipulations');
            csv.splice(csv.indexOf(x), 1);
            setcsvdata(csv);
          }
        });
      }
    } catch (error) {
      console.error('Error adding list:', error);
    }
  };

  const upload = new FormData();


  const SelectAll = () => {
    try {
      const checkboxes = document.querySelectorAll('input');
      if (checkboxes[0].checked == true) {
        csv = [
          ["key", "refund_amount", "phone", "email", "Account_Number", "IFSC_CODE", "BANK_NAME", "Account_HolderName","PANCARD","GSTNO","TXNID"]
        ];
        // checkboxes.forEach((element) => {
        //   if (element.type === 'checkbox') {
            
        //     element.checked = true;
        //   }
        // });

        renderdata.forEach((e,index) => {
         if (e.Refund_Status==="Refund") {
           // Select only "Refund" status checkboxes
           let checkbox = checkboxes[index + 1]; // Offset by 1 for header checkbox
           if (checkbox) {
             checkbox.checked = true;
           }
          csv.push([e.Regiterationid, e.ErnestMoneyDeposit, e.Mobile_No, e.Email, e.Account_Number, e.IFSC_CODE, e.BANK_NAME, e.Account_HolderName,e.PAN_No,e.GST_No,e.easepayid]);
         }
        });
        setcsvdata(csv);
      } else{
        csv = [
          ["key", "refund_amount", "phone", "email", "Account_Number", "IFSC_CODE", "BANK_NAME", "Account_HolderName","PANCARD","GSTNO","TXNID"]
        ];
        setcsvdata(csv);
        checkboxes.forEach((element,index) => {
          if (index !==0) {
            element.checked = false;
          }
        });
      }
    } catch (error) {
      console.error('Error selecting all:', error);
    }

  }

  const Savefile = async () => {
    try {
      const textToSave = csvdata.map((item) => Object.values(item).join('|')).join('\n');
      const blob = new Blob([textToSave], { type: 'text/plain;charset=utf-8' });
      upload.append('EcsUpload', blob, 'data.txt');
      saveAs(blob, 'data.txt');
    } catch (error) {
      console.error('Error saving file:', error);
    }
  }

  const Sendfile = async () => {
    try {
      const textToSave = csvdata.map((item) => Object.values(item).join('|')).join('\n');
      console.log("csvdata",csvdata);
      console.log("id",id);
      console.log("AuctionName",AuctionName);
      console.log("textToSave",textToSave);
      console.log("EToken",EToken);
      
      let data = await SendRefund(csvdata, id, AuctionName, textToSave,EToken);
      console.log("data",data);
      
      if (data.success==true) {
        alert(data.message);
        window.location.reload()
      }
      else{
        alert(data.message);
        window.location.reload()
      }
      //await EcsUpload(textToSave,id, AuctionName)
    } catch (error) {
      console.error('Error sending file:', error);
    }
  }

  const paginate = (pageNumber) => {
    try {
      setCurrentPage(pageNumber);
    } catch (error) {
      console.error('Error paginating:', error);
    }
  };

  async function GenerateTokenFor(e) {
    e.preventDefault();
    let data = await CreateToken('Tender Refund');
    document.getElementById('tokencopys').innerText = data
    SetEToken(data)
    settoken(false)
  }
  return (
    <div style={{ justifyContent: 'center', display: 'grid' }}>
      <h1><b>GenerateRefund </b></h1>
      <hr></hr>
      <table className="table table-striped">
        <thead>
          <tr>
            <th scope="col">Checkbox</th>
            <th scope="col">Refund_Status</th>
            <th scope="col">Regiterationid</th>
             <th scope="col">Bidder_CompanyName</th>
            <th scope="col">Refund Amount</th>
            <th scope="col">GST_No</th>
            <th scope="col">PAN_No</th>
            <th scope="col">WinningStatus</th>
            <th scope="col">Tender_Name</th>

          </tr>
        </thead>
        <tbody>
          <span style={{ display: 'flex' }}>
            <input type='checkbox' style={{ height: '2rem', width: '2rem', borderRadius: '1px' }}  onClick={SelectAll}></input>
            <p>All</p>
          </span>
          {currentItems&&currentItems.map((e, index) => (
            <tr key={index}>
              <td><input type='checkbox' style={{ height: '2rem', width: '2rem', borderRadius: '1px' }} className="checkbox" disabled onChange={(target)=>addlist(target,e)} ></input></td>
              <td  className={e.Refund_Status === 'Refund' ? 'text-bg-danger' : 'text-bg-warning'}>{e.Refund_Status}</td> 
              <td>{e.Regiterationid}</td>
               <td>{e.Bidder_CompanyName}</td>
              <td>{e.ErnestMoneyDeposit}</td>
              <td>{e.GST_No}</td>
              <td>{e.PAN_No}</td>
              <td className={e.WinningStatus === 'Tender Winner' ? 'text-bg-success' : 'text-bg-danger'}>{e.WinningStatus}</td>
              <td>{e.Tender_Name}</td>
            </tr>
          ))}
        </tbody>
      </table>
      
      <div class="card" style={{ width: '100%',height:'100%', position: "absolute", left: "0", bottom: "0" }} hidden={hide}>
        <div class="card-body">
          <h6>Send Message</h6>  
          <div class="card form-control" style={{width: "100%"}}>
            <div class="card-body">
              <h5 class="card-title">Generate Token</h5>
              <textarea class="form-control" id='tokencopys' value={EToken}></textarea>
              <button hidden={!gentoken} className='btn btn-success mx-2' style={{ backgroundColor: "rgb(10, 200, 150)", border: "none", borderRadius: "10px" }} onClick={GenerateTokenFor}>Generate Token</button>
            </div>
          </div>
          <textarea id='message' className='form-control my-3' onChange={(e) => { setMessage(e.target.value) }} placeholder='Please Enter The Message' ></textarea>
          <button className='btn btn-success mx-2' onClick={Sendfile} hidden={gentoken}>Submit</button>
          <button className='btn btn-danger' onClick={(x) => sethide(true)}>close</button>
        </div>
      </div>



      <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <ul className="pagination">
                        {Array(Math.ceil(renderdata.length / itemsPerPage))
                            .fill()
                            .map((_, index) => (
                                <li key={index} className="page-item">
                                    <button onClick={() => paginate(index + 1)} className="page-link">
                                        {index + 1}
                                    </button>
                                </li>
                            ))}
                    </ul>
      </div>



      <button className='btn btn-success my-3' onClick={Savefile}>Check file</button>
      <button className='btn btn-primary' onClick={() => sethide(!hide)}  hidden={!renderdata.some(item => item.Refund_Status === "Refund")} > Submit</button>
    </div>

  )
}

export default GenerateRefund